import { RootState } from '../../store';

export const selectAuthData = (state: RootState) => state.auth;
